import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";
import { AdminUsersSuccessResponse } from "../../../service/api-response/AdminUsersSuccessResponse";

export const LIST_ADMIN_USERS_SUCCESS = "ADMIN-USER:LIST_ADMIN_USERS_SUCCESS";

export interface ListAdminUsersSuccessAction extends Action {
  type: typeof LIST_ADMIN_USERS_SUCCESS;
  organization: OrganizationKeyName;
  data: AdminUsersSuccessResponse;
}

export const listAdminUsersSuccessAction = (
  organization: OrganizationKeyName,
  data: AdminUsersSuccessResponse
): ListAdminUsersSuccessAction => ({
  type: LIST_ADMIN_USERS_SUCCESS,
  organization,
  data,
});
